import {useCallback, useEffect, useState} from 'react';

interface SvgModule {
    default: string;
}

const importAsModule = async (iconName: string) => {
    try {
        const module = (await import(
            `../../assets/images/icons/${iconName}`
        )) as SvgModule;

        return module.default;
    } catch (e) {
        // console.log(e);
    }
};

const importFromUrl = async (url: string) => {
    try {
        const response = await fetch(url, {cache: 'force-cache'});

        return await response.text();
    } catch (e) {
        // console.log(e);
    }
};

export const useFetchSVG = (
    primaryColor: string,
    secondaryColor: string,
    color?: 'primary' | 'secondary' | string
) => {
    const [imageDataRaw, setImageDataRaw] = useState<string>();
    const [imageData, setImageData] = useState<string>();
    const [imageFetched, setImageFetched] = useState<boolean>(false);

    const replaceColor = useCallback(
        (rawData: string) => {
            if (color) {
                let replacingColor = color;

                if (color == 'primary') {
                    replacingColor = primaryColor;
                } else if (color == 'secondary') {
                    replacingColor = secondaryColor;
                }
                rawData = rawData.replace(/#1392CD/gi, replacingColor);
                rawData = rawData.replace(/#204380/gi, replacingColor);
            } else {
                rawData = rawData.replace(/#1392CD/gi, secondaryColor);
                rawData = rawData.replace(/#204380/gi, primaryColor);
            }

            return rawData;
        },
        [color, primaryColor, secondaryColor]
    );

    const fetchIcon = useCallback(
        async (url: string, as: 'MODULE' | 'URL') => {
            if (url != null) {
                try {
                    let svg: string;

                    if (as == 'MODULE') {
                        svg = await importAsModule(url);
                    } else {
                        svg = await importFromUrl(url);
                    }

                    setImageDataRaw(svg);

                    svg = replaceColor(svg);

                    const imageBase64: string = btoa(svg);

                    setImageData(`data:image/svg+xml;base64, ${imageBase64}`);
                    setImageFetched(true);
                } catch (e) {
                    // handle error here
                }
            }
        },
        [replaceColor]
    );

    useEffect(() => {
        if (imageDataRaw) {
            const imageBase64: string = btoa(replaceColor(imageDataRaw));

            setImageData(`data:image/svg+xml;base64, ${imageBase64}`);
        }
    }, [color]); // only updating on color for now, we can change this later if needed

    return {
        imageData,
        fetchIcon,
        imageFetched,
    };
};
